// @flow

import React, { type Node } from 'react';
import { usePayment } from '../context';
import {
  Container,
  Content,
  ErrorIcon,
  Title,
  Subtitle,
  RetryButton,
} from './error-screen.styles';

const FALLBACK_ERROR_MESSAGE = 'Ocurrió un error al procesar tu solicitud. Por favor, inténtalo de nuevo.';

export function ErrorScreen(): Node {
  const { data, dispatch } = usePayment();

  return (
    <Container>
      <Content>
        <ErrorIcon>
          <ErrorSvg />
        </ErrorIcon>

        <Title>Algo salió mal</Title>
        <Subtitle>{data.errorMessage || FALLBACK_ERROR_MESSAGE}</Subtitle>

        <RetryButton onClick={() => dispatch({ type: 'RETRY' })}>
          Intentar nuevamente
        </RetryButton>
      </Content>
    </Container>
  );
}

export function ErrorSvg(): Node {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99999 2.08334L18.3333 16.6667H1.66666L9.99999 2.08334Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 7.5V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="10" cy="13.75" r="0.75" fill="currentColor" />
    </svg>
  );
}
